import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  styled,
} from "@mui/material";

import { DIALOG_PADDING } from "@/constants/layout";
import { Z_INDEX } from "@/constants/zIndex";
import { useAppDispatch, useAppSelector } from "@/store";
import { hideAlertDialog } from "@/store/slices/alertDialogSlice";

const Title = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
}));

const Content = styled(DialogContent)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
}));

const Actions = styled(DialogActions)(({ theme }) => ({
  padding: `${DIALOG_PADDING}px ${DIALOG_PADDING * 2}px`,
  backgroundColor: theme.palette.background.paper,
}));

const Message = styled(DialogContentText)({ whiteSpace: "pre-wrap" });

export default function AlertDialog() {
  const {
    head,
    message,
    submitText,
    cancelText,
    onSubmit,
    onClose,
    onCancel,
    open,
    submitColor,
  } = useAppSelector((state) => state.alertDialog);
  const dispatch = useAppDispatch();

  const handleClose = () => {
    onClose?.();
    dispatch(hideAlertDialog());
  };

  const handleCancel = () => {
    onCancel?.();
    dispatch(hideAlertDialog());
  };

  const handleSubmit = () => {
    onSubmit?.();
    dispatch(hideAlertDialog());
  };

  return (
    <Dialog
      sx={{ zIndex: Z_INDEX.DIALOG }}
      disableRestoreFocus
      open={open}
      onClose={handleClose}
    >
      <Title>{head}</Title>
      <Content>
        <Message>{message}</Message>
      </Content>
      <Actions>
        {!!cancelText && (
          <Button
            disableElevation
            variant="contained"
            color="secondary"
            size="small"
            onClick={handleCancel}
          >
            {cancelText}
          </Button>
        )}
        <Button
          disableElevation
          variant="contained"
          color={submitColor}
          size="small"
          onClick={handleSubmit}
        >
          {submitText}
        </Button>
      </Actions>
    </Dialog>
  );
}
